module.exports = __webpack_public_path__ + "img/service_img1.8e3734e3.png";